import { Injectable, Inject } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({ providedIn: 'root' })
export class MaterialSearchTermsService {
  public dataLength = 0;
  public selectedData;
  currentSavedOptions;

  private optionSaver = {
    searchTerms: {},
    pageNumber: 0,
    pageSize: 0,
    pageMode: '4 Columns'
  };

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService
  ) {
    this.currentSavedOptions = this.optionSaver;
  }

  saveSearchTermsInLocal(key, val): void {
    let currentlyStoredTableOptions = null;
    const unparsedStorageObject = this.storage.get(key);

    if (unparsedStorageObject && unparsedStorageObject !== undefined) currentlyStoredTableOptions = JSON.parse(unparsedStorageObject);

    if (currentlyStoredTableOptions) this.currentSavedOptions = currentlyStoredTableOptions;
    else this.currentSavedOptions = this.optionSaver;

    this.currentSavedOptions.searchTerms = val;
    this.storage.set(key, JSON.stringify(this.currentSavedOptions));
  }


  getSearchTermsFromLocal(key) {
    let termsFound = null;

    if (this.storage.get(key)) {
      const currentSavedOptions = JSON.parse(this.storage.get(key));
      if (currentSavedOptions && currentSavedOptions.searchTerms) termsFound = currentSavedOptions.searchTerms;
    }
    return termsFound;
  }


  saveTableOptionsInLocal(key, pageNumber, pageSize, pageMode) {
    const termsFromStorage = this.storage.get(key);
    const currentlyStoredTableOptions = termsFromStorage ? JSON.parse(this.storage.get(key)) : null;

    if (currentlyStoredTableOptions) this.currentSavedOptions = currentlyStoredTableOptions
    else this.currentSavedOptions = this.optionSaver;

    this.currentSavedOptions.pageNumber = pageNumber;
    this.currentSavedOptions.pageSize = pageSize;
    this.currentSavedOptions.pageMode = pageMode;

    this.storage.set(key, JSON.stringify(this.currentSavedOptions));
  }


  getTableOptionsFromLocal(key) {
    if (this.storage.get(key)) this.currentSavedOptions = JSON.parse(this.storage.get(key));
    return this.currentSavedOptions;
  }
}